<template>
	<div>
		<!-- backurl="/supplier_product" -->
		<CubePage type="myorder-view" title="价格日历" backurl="/productEdit">
			<div slot="content" class="content">
				<div class="qqpages">
					<van-calendar title="日历" color="#07c160" :poppable="false" :show-confirm="false" :show-title="false"
						:default-date="rq" :formatter="formatter" @select="showCalender"
						:style="{ height: 'calc(100% - 50px)' }" v-model="poppable">
						<template #bottom-info="item">
							<span class="mark-red">{{item.bottomInfo}}</span>
						</template>
					</van-calendar>
				</div>
				<van-goods-action v-if="setZZdates.length>0">
					<van-goods-action-button type="primary" text="保存" @click="onSave" />
					<van-goods-action-icon />
					<van-goods-action-icon text="重置" @click="rest" />
					<van-goods-action-icon />
				</van-goods-action>
				<van-goods-action v-else>
					<van-goods-action-button type="danger" text="清除全部"
					 :disabled="zzDates.length ==0" @click="restAll" />
				</van-goods-action>
			</div>
		</CubePage>

	</div>
</template>

<script>
	import CubePage from '../../TP/cube-page.vue'
	import * as util from '@/utils/network'
	import {
		getdiffdate
	} from '@/utils/date.js'
	import {
		Dialog,
		Toast
	} from 'vant';
	export default {
		components: {
			CubePage
		},
		data() {
			return {
				poppable: false,
				showCalendar: false,
				show: false,
				qjshow: false,
				value: '',
				username: '',
				entity: {
					maxnum: '',
					minnum: '',
					dj: '',
					jg: '',
					num: ''
				},
				rq: null,
				weeks: ['周天', '周一', '周二', '周三', '周四', '周五', '周六'],
				ybvisb: false,
				zdDates: [],
				weekDates: [],
				selAllDates: null, //选中范围的全部日期
				weekSelDates: null, //选中星期的全部日期
				defaultDate: null, //默认选中的日期
				zzDates: [], //最终日期集合
				initData: [], //初始数组
				skuObj: null,
				setZZdates: [],
				addEntity: null,
				saveDatas: [],

			}
		},
		created() {
			let obj = this.$route.params.backobj
			let skuitem = this.$store.getters.getsupSetObj
			this.skuObj = skuitem
			if (obj) {
			  console.log('新设置的数据data',obj.entity)
				this.addEntity = obj.entity
				this.setZZdates = obj.zzdates
			}
			this.getCalendar()
		},
		methods: {
			//保存
			async onSave() {
				let that = this
        console.log('init',that.initData);
				var newData = that.setZZdates
        console.log('new',newData);
        //return false
        var submitdata = []
				for (var j = 0; j < newData.length; j++) {
				  var date = newData[j];
				  /*if (that.initData[date]){
				    console.log('date',that.initData[date])
          }*/
          //console.log('date',that.initData[date])
          /**************leo**************/
          /*if (that.initData[date]){
            that.initData[date] = {
              id: that.initData[date].id,
              buyNumMax: that.addEntity.buyNumMax,
              buyNumMin: that.addEntity.buyNumMin,
              date: newData[j],
              goods_id: that.skuObj.goods_id,
              spec_sku_id: that.skuObj.spec_sku_id,
              price: that.addEntity.price,
              priceRetail: that.addEntity.priceRetail,
              stock: that.addEntity.stock,
            }
          }*/
          /**************leo**************/

          var id = that.initData[date] ? that.initData[date].id : '';
					submitdata.push({
            id: id,
						buyNumMax: that.addEntity.buyNumMax,
						buyNumMin: that.addEntity.buyNumMin,
						date: newData[j],
						goods_id: that.skuObj.goods_id,
						spec_sku_id: that.skuObj.spec_sku_id,
						price: that.addEntity.price,
						priceRetail: that.addEntity.priceRetail,
						stock: that.addEntity.stock,
					})
				}
				//console.log('newData',that.initData)
				//return false;
				// var dataSave = {
				// 	id: that.skuObj.goods_id,
				// 	spec_sku_id: that.skuObj.spec_sku_id,
				// 	data: submitdata
				// }
				//that.setData(that.initData)
				that.setData(submitdata)
				// console.log('传：', dataSave)
				// var url = "/addons/litestore/api.supplier/skuCalendar"
				// await util.post(url, dataSave,
				// 	function(res) {
				// 		Dialog.alert({
				// 			title: '温馨提示',
				// 			message: res.msg
				// 		});
				// 		that.addEntity = null
				// 		that.setZZdates = []
				// 		that.getCalendar()
				// 	});
			},
			async setData(data) {
				let that = this
				var dataSave = {
					id: that.skuObj.goods_id,
					spec_sku_id: that.skuObj.spec_sku_id,
					data: data
				}
				console.log('传：', dataSave)
				var url = "/addons/litestore/api.supplier/skuCalendar"
				await util.post(url, dataSave,
					function(res) {
						Dialog.alert({
							title: '温馨提示',
							message: res.msg
						}).then(() => {
							that.addEntity = null
							that.setZZdates = []
							that.getCalendar()
						});
					});
			},
			//重置所有  格式化
			restAll() {
				Dialog.confirm({
						title: '提示',
						message: '确认要删除所有设置吗？',
					})
					.then(() => {
						this.setData([])
						this.getCalendar()
					})
					.catch(() => {
						// on cancel
					});
			},
			//重置按钮
			rest() {
				Dialog.confirm({
						title: '提示',
						message: '确认要重置刚设置的内容吗？',
					})
					.then(() => {
						this.addEntity = null
						this.setZZdates = []
					})
					.catch(() => {
						// on cancel
					});
			},
			async getCalendar() {
				let that = this
				var url = "/addons/litestore/api.supplier/skuCalendar"
				await util.get(url, {
						id: that.skuObj.goods_id,
						spec_sku_id: that.skuObj.spec_sku_id
					},
					function(res) {
						let resdata = res
						console.log(resdata.length)
						if (resdata.length == 0) {
							that.zzDates = []
							that.initData = []
						} else {
							let nowDate = that.formatDate(new Date())
							resdata.map(item => {
								if (item.date >= nowDate) {
									that.zzDates.push(item)
                  that.initData[item.date] = item;
								}
							})
						}
						//console.log('init',that.initData)
					});
			},
			showCalender(date) {
				console.log(this.skuObj)
				this.$router.push({
					name: 'skuSetting',
					params: {
						defaultDate: date,
						sku: this.skuObj
					}
				})
			},
			closed() {
				console.log('sdfsd')
			},
			formatter(day) {
				let that = this
				let dds = that.zzDates;
				let newdd = that.formatDate(day.date)
				let nowDate = that.formatDate(new Date())
				// if (newdd < nowDate) {
				// 	return day
				// } else {
				for (var i = 0; i < dds.length; i++) {
					if (dds[i].date == newdd) {
						day.bottomInfo = dds[i].price
					}
				}
				let setdds = that.setZZdates;
				if (setdds != null && setdds.length > 0) {
					for (var i = 0; i < setdds.length; i++) {
						if (setdds[i] == newdd) {
							day.bottomInfo = that.addEntity.price
							day.className = 'champion-day';
						}
					}
				}
				return day;
				// }
			},
			formatDate(date) {
				let m = (date.getMonth() + 1) * 1 > 9 ? (date.getMonth() + 1) * 1 : ('0' + (date.getMonth() + 1) * 1)
				let d = date.getDate() > 9 ? date.getDate() : '0' + date.getDate()
				return `${date.getFullYear()}-${m}-${d}`;
			},
			onSubmit() {
				this.poppable = false
				this.show = false
				this.$router.push({
					name: 'pEditSku'
				})
			}
		}
	}
</script>
<style type="text/css" lang="less" scoped>
	.van-calendar {
		.van-calendar__body>.van-calendar__days>.van-calendar__day>.van-calendar__bottom-info::v-deep {
			color: #00aaff !important;
		}

		.mark-red {
			color: #ff5500;
		}

		/deep/ .champion-day {
			color: #ffffff;
			background: #07c160;

			.mark-red {
				color: #ffffff;
			}
		}
	}

	.van-calendar__day--disabled {
		.mark-red {
			color: #d0d0d0;
		}
	}

	.col-form {
		padding: 0 !important;

		.van-cell {
			flex-direction: column;
		}
	}

	.qqpages {
		height: calc(100vh - 44px);
		padding: 8px 8px 25px 8px;
		box-sizing: border-box;
		background-color: #f4f4f4;

		.btns {
			padding: 10px 0;
			display: flex;
			justify-content: center;

			.van-button {
				margin: 0 10px;
			}
		}
	}
</style>
